import { isObject } from '../is-object';
export function isNode(node) {
  if (!isObject(node)) {
    return false;
  }
  return node.isNode;
}